var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{staticClass:"title",staticStyle:{"height":"80px"},attrs:{"align-center":""}},[_c('span',{staticClass:"pl-4"},[_vm._v("个人预约记录")])]),_c('reservation-list',{staticClass:"px-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }